import { AlertsButton } from '../common/AlertsButton';

interface Props {
    isAlertOn: boolean;
    label?: string;
    onClick: () => void;
}

export const CloManagerAlertsButton = ({ isAlertOn, label, onClick }: Props) => {
    return (
        <div className="email-alert-wrap">
            <AlertsButton isSelected={isAlertOn} onClick={onClick} label={label} />
        </div>
    );
};
